import { useInvitesByOrg } from "@/components/InvitationDialogStacks/hooks/useInvitesByOrg";
import { UseSyncActiveInvite } from "@/components/InvitationDialogStacks/hooks/UseSyncActiveInvite";
import InviteCard from "@/components/InvitationDialogStacks/InviteCard";
import { WorkspaceInvite } from "@/types/workspace-invite";

const InviteList = ({ invites }: { invites: WorkspaceInvite[] }) => {
  const invitesByOrg = useInvitesByOrg(invites);
  const sortedSyncActiveInvites = UseSyncActiveInvite(invites);
  return (
    <>
      {sortedSyncActiveInvites.map((invite) => (
        <InviteCard
          key={invite.id}
          invite={invite}
          sameOrgInvites={invitesByOrg[invite.workspace.organization_id] || []}
        />
      ))}
    </>
  );
};

export default InviteList;
